import React, { useCallback, useEffect, useState } from "react";
import { CountryDropdown } from "react-country-region-selector";
import dayjs from "dayjs";
import { Input, Select, DatePicker, Radio } from "antd";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

const shipClasses = [
  "IRS",
  "ABS",
  "KR",
  "DNV",
  "CCS",
  "MKK",
  "VNV",
  "LR",
  "Others",
];
const shiptypes = [
  "Oil Tanker",
  "Chemical Tanker",
  "Oil/Chem Tanker",
  "LPG",
  "LNG",
  "Bulk Carrier",
  "General Cargo",
  "Container",
  "Ro-Ro",
  "Others",
];

function StaffShips({ id }) {
  const [access_ip, set_access_ip] = useState("");
  const [errors, set_errors] = useState({});
  const [ship_class, set_ship_class] = useState(" ");
  const [other_ship_class, set_other_ship_class] = useState("");
  const [ship_type, set_ship_type] = useState(" ");
  const [other_ship_type, set_other_ship_type] = useState("");
  const [vessel_name, set_vessel_name] = useState("");
  const [imo_number, set_imo_number] = useState("");
  const [flag, set_flag] = useState("");
  const [deadweight, set_deadweight] = useState("");
  const [grt, set_grt] = useState("");
  const [maximum_draft, set_maximum_draft] = useState("");
  const [email_address, set_email_address] = useState("");
  const [length_overall, set_length_overall] = useState("");
  const [date_of_delivery, set_date_of_delivery] = useState(null);
  const [call_sign, set_call_sign] = useState("");
  const [telephone, set_telephone] = useState("");
  const [sat_c, set_sat_c] = useState("");
  const [length_between_perpendiculars, set_length_between_perpendiculars] =
    useState("");
  const [moulded_depth, set_moulded_depth] = useState("");
  const [keel_to_masthead, set_keel_to_masthead] = useState("");
  const [bow_to_center_manifold, set_bow_to_center_manifold] = useState("");
  const [distance_bridge_manifold, set_distance_bridge_manifold] = useState("");
  const [forward_manifold, set_forward_manifold] = useState("");
  const [aft_manifold, set_aft_manifold] = useState("");
  const [parallel_body_distance, set_parallel_body_distance] = useState("");
  const [tpc_at_summer_draft, set_tpc_at_summer_draft] = useState("");
  const [constant_weight, set_constant_weight] = useState("");
  const [max_height_above_waterline, set_max_height_above_waterline] =
    useState("");
  const [full_mast, set_full_mast] = useState(0);
  const [lightship, set_lightship] = useState("");
  const [normal_ballast, set_normal_ballast] = useState("");
  const [loaded_summer_deadweight, set_loaded_summer_deadweight] = useState("");
  const [gross_tonnage, set_gross_tonnage] = useState("");
  const [suez_canal_tonnage, set_suez_canal_tonnage] = useState("");
  const [panama_canal_tonnage, set_panama_canal_tonnage] = useState("");
  const [net_tonnage, set_net_tonnage] = useState("");
  const [extreme_breadth, set_extreme_breadth] = useState("");

  const handleDateChange = (date, dateString) => {
    const formattedDate = dateString;
    set_date_of_delivery(formattedDate);
  };

  const VIEW_API = useCallback((ship_Id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_Id);
      post(ApiURL.view_ship_details_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const Ship_Data = res?.ship_data;
          set_access_ip(Ship_Data?.access_ip);
          set_ship_class(Ship_Data?.ship_class);
          set_other_ship_class(Ship_Data?.other_ship_class);
          set_ship_type(Ship_Data?.ship_type);
          set_other_ship_type(Ship_Data?.other_ship_type);
          set_vessel_name(Ship_Data?.vessel_name);
          set_imo_number(Ship_Data?.imo_number);
          set_flag(Ship_Data?.flag);
          set_deadweight(Ship_Data?.deadweight);
          set_grt(Ship_Data?.grt);
          set_maximum_draft(Ship_Data?.maximum_draft);
          set_email_address(Ship_Data?.email_address);
          set_length_overall(Ship_Data?.length_overall);
          set_sat_c(Ship_Data?.sat_c);
          set_length_between_perpendiculars(
            Ship_Data?.length_between_perpendiculars
          );
          set_moulded_depth(Ship_Data?.moulded_depth);
          set_keel_to_masthead(Ship_Data?.keel_to_masthead);
          set_bow_to_center_manifold(Ship_Data?.bow_to_center_manifold);
          set_distance_bridge_manifold(Ship_Data?.distance_bridge_manifold);
          set_forward_manifold(Ship_Data?.forward_manifold);
          set_aft_manifold(Ship_Data?.aft_manifold);
          set_parallel_body_distance(Ship_Data?.parallel_body_distance);
          set_tpc_at_summer_draft(Ship_Data?.tpc_at_summer_draft);
          set_constant_weight(Ship_Data?.constant_weight);
          set_max_height_above_waterline(Ship_Data?.max_height_above_waterline);
          set_full_mast(Ship_Data?.full_mast ? 1 : 0);
          set_lightship(Ship_Data?.lightship);
          set_normal_ballast(Ship_Data?.normal_ballast);
          set_loaded_summer_deadweight(Ship_Data?.loaded_summer_deadweight);
          set_gross_tonnage(Ship_Data?.gross_tonnage);
          set_suez_canal_tonnage(Ship_Data?.suez_canal_tonnage);
          set_panama_canal_tonnage(Ship_Data?.panama_canal_tonnage);
          set_net_tonnage(Ship_Data?.net_tonnage);
          set_telephone(Ship_Data?.telephone);
          set_date_of_delivery(Ship_Data?.date_of_delivery);
          set_call_sign(Ship_Data?.call_sign);
          set_extreme_breadth(Ship_Data?.extreme_breadth);
        } else {
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } finally {
    }
  }, []);

  useEffect(() => {
    if (id) {
      VIEW_API(id);
    }
  }, [id]);

  const handleShipClassChange = (value) => {
    set_ship_class(value);
    if (value !== "Others") {
      set_other_ship_class("");
    }
  };

  const handleOtherShipClassChange = (e) => {
    set_other_ship_class(e.target.value);
  };

  const handleShipTypeChange = (value) => {
    set_ship_type(value);
    if (value !== "Others") {
      set_other_ship_type("");
    }
  };

  const handleOtherShipTypeChange = (e) => {
    set_other_ship_type(e.target.value);
  };

  return (
    <>
      <h3 style={{ marginTop: "15px" }}>Ship Basic Information </h3>
      <div className="row">
        <div
          style={{
            background: "#fff",
          }}
          className="col-12"
        >
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Name</label>
                <Input
                  disabled
                  value={vessel_name}
                  placeholder="vessel name"
                  onChange={(e) => set_vessel_name(e.target.value)}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>IMO NUMBER</label>
                <Input
                  disabled
                  value={imo_number}
                  maxLength={7}
                  placeholder="Imo number"
                  onChange={(e) => set_imo_number(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Ship Class</label>
                <div className="row">
                  <div className={ship_class === "Others" ? "col-8" : "col-12"}>
                    <Select
                      disabled
                      style={{ width: "100%" }}
                      value={ship_class}
                      onChange={handleShipClassChange}
                    >
                      <Select.Option key={"Select-Ship-Class"} value=" ">
                        Select Ship Class
                      </Select.Option>
                    </Select>
                  </div>
                  {ship_class === "Others" && (
                    <>
                      <div className="col-4">
                        <Input
                          disabled
                          placeholder="Enter New Ship Class"
                          value={other_ship_class}
                          onChange={handleOtherShipClassChange}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="col-6">
              <div className="input-box">
                <label>Deadweight</label>
                <Input
                  disabled
                  value={deadweight}
                  placeholder="--- deadweight ----"
                  onChange={(e) => set_deadweight(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="row">
            {/* ship type*/}
            <div className="col-6">
              <div className="input-box">
                <label>Ship Type</label>
                <div className="row">
                  <div className={ship_type === "Others" ? "col-8" : "col-12"}>
                    <Select
                      disabled
                      style={{ width: "100%" }}
                      value={ship_type}
                      onChange={handleShipTypeChange}
                    >
                      <Select.Option key={"Select-Ship-type"} value=" ">
                        Select Ship Type
                      </Select.Option>

                      {shiptypes.map((shipType) => (
                        <Select.Option key={shipType} value={shipType}>
                          {shipType}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                  {ship_type === "Others" && (
                    <>
                      <div className="col-4">
                        <Input
                          disabled
                          placeholder="Enter New Ship Type"
                          value={other_ship_type}
                          onChange={handleOtherShipTypeChange}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Flag</label>
                <CountryDropdown
                  disabled
                  style={{ width: "100%", height: "32px" }}
                  value={flag}
                  onChange={(value) => set_flag(value)}
                  className="ant-input css-dev-only-do-not-override-djtmh8 ant-input-outlined"
                />
              </div>
            </div>
          </div>

          <div className="row">
            {/*GRT  */}
            <div className="col-6">
              <div className="input-box">
                <label>GRT</label>
                <Input
                  disabled
                  value={grt}
                  placeholder="Vessel GRT"
                  onChange={(e) => set_grt(e.target.value)}
                />
              </div>
            </div>
            {/* Maximum Draft */}
            <div className="col-6">
              <div className="input-box">
                <label>Maximum Draft</label>
                <Input
                  disabled
                  value={maximum_draft}
                  placeholder="Value of draft"
                  onChange={(e) => set_maximum_draft(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Email Address</label>
                <Input
                  disabled
                  value={email_address}
                  placeholder="Email Address"
                  onChange={(e) => {
                    set_email_address(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Length overall</label>
                <Input
                  disabled
                  value={length_overall}
                  placeholder="Length overall"
                  onChange={(e) => {
                    set_length_overall(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>SAT-C</label>
                <Input
                  disabled
                  value={sat_c}
                  placeholder="Sat-C"
                  onChange={(e) => {
                    set_sat_c(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Length Between Perpendiculars </label>
                <Input
                  disabled
                  value={length_between_perpendiculars}
                  placeholder="Length Between Perpendiculars"
                  onChange={(e) => {
                    set_length_between_perpendiculars(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Moulded Depth</label>
                <Input
                  disabled
                  value={moulded_depth}
                  placeholder="Moulded Depth"
                  onChange={(e) => {
                    set_moulded_depth(e.target.value);
                  }}
                />
              </div>
            </div>

            <div className="col-6">
              <div className="input-box">
                <label>Keel to Masthead</label>
                <Input
                  disabled
                  value={keel_to_masthead}
                  placeholder="Keel to Masthead"
                  onChange={(e) => {
                    set_keel_to_masthead(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Bow to Center Manifold</label>
                <Input
                  disabled
                  value={bow_to_center_manifold}
                  placeholder="Bow to Center Manifold"
                  onChange={(e) => {
                    set_bow_to_center_manifold(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Distance Bridge Manifold</label>
                <Input
                  disabled
                  value={distance_bridge_manifold}
                  placeholder="Distance Bridge Manifold"
                  onChange={(e) => {
                    set_distance_bridge_manifold(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Forward to mid point Manifold </label>
                <Input
                  disabled
                  value={forward_manifold}
                  placeholder="Forward to mid point Manifold"
                  onChange={(e) => {
                    set_forward_manifold(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Aft to midpoint Manifold</label>
                <Input
                  disabled
                  value={aft_manifold}
                  placeholder="Aft to midpoint Manifold"
                  onChange={(e) => {
                    set_aft_manifold(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>TPC At Summer Draft</label>
                <Input
                  disabled
                  value={tpc_at_summer_draft}
                  placeholder="TPC at Summer draft"
                  onChange={(e) => {
                    set_tpc_at_summer_draft(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>parallel Body Distances</label>
                <Input
                  disabled
                  value={parallel_body_distance}
                  placeholder="parallel Body Distances"
                  onChange={(e) => {
                    set_parallel_body_distance(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Constant Weight</label>
                <Input
                  disabled
                  value={constant_weight}
                  placeholder="Constant Weight"
                  onChange={(e) => {
                    set_constant_weight(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Maximum Height Above Water Line </label>
                <Input
                  disabled
                  value={max_height_above_waterline}
                  placeholder="Maximum Height Above Water Line"
                  onChange={(e) => {
                    set_max_height_above_waterline(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-6">
              <div className="input-box">
                <label>Does Vessel have Full Mast/Collapsed Mast </label>
                <br />
                <Radio.Group
                  onChange={(e) => set_full_mast(e.target.value)}
                  value={full_mast}
                >
                  <Radio value={0}>Collapsed Mast</Radio>
                  <Radio value={1}>Full Mast</Radio>
                </Radio.Group>
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Lightship</label>
                <Input
                  disabled
                  value={lightship}
                  placeholder="Lightship"
                  onChange={(e) => {
                    set_lightship(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Normal Ballast</label>
                <Input
                  disabled
                  value={normal_ballast}
                  placeholder="Normal Ballast"
                  onChange={(e) => {
                    set_normal_ballast(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>At Loaded Summer deadweight</label>
                <Input
                  disabled
                  value={loaded_summer_deadweight}
                  placeholder="Loaded Summer deadweight"
                  onChange={(e) => {
                    set_loaded_summer_deadweight(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Gross Tonnage</label>
                <Input
                  disabled
                  value={gross_tonnage}
                  placeholder="Gross Tonnage"
                  onChange={(e) => {
                    set_gross_tonnage(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Suez Canal Tonnage</label>
                <Input
                  disabled
                  value={suez_canal_tonnage}
                  placeholder="Suez Canal Tonnage"
                  onChange={(e) => {
                    set_suez_canal_tonnage(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Tonnage</label>
                <Input
                  disabled
                  value={net_tonnage}
                  placeholder="Tonnage"
                  onChange={(e) => {
                    set_net_tonnage(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Panama Canal Tonnage</label>
                <Input
                  disabled
                  value={panama_canal_tonnage}
                  placeholder="panama canal tonnage"
                  onChange={(e) => {
                    set_panama_canal_tonnage(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Extreme Breadth</label>
                <Input
                  disabled
                  value={extreme_breadth}
                  placeholder="Extreme breadth"
                  onChange={(e) => {
                    set_extreme_breadth(e.target.value);
                  }}
                />
              </div>
            </div>

            <div className="col-6">
              <div className="input-box">
                <label>Access IP</label>
                <Input
                  disabled
                  value={access_ip}
                  placeholder="Access IP"
                  onChange={(e) => {
                    set_access_ip(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Call Sign</label>
                <Input
                  disabled
                  value={call_sign}
                  placeholder="call sign"
                  onChange={(e) => {
                    set_call_sign(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Telephone</label>
                <Input
                  disabled
                  value={telephone}
                  maxLength={15}
                  placeholder="telephone"
                  onChange={(e) => {
                    set_telephone(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <label className="block-label">Date</label>
              <DatePicker
                style={{ width: "100%" }}
                value={date_of_delivery ? dayjs(date_of_delivery) : ""}
                onChange={handleDateChange}
              />
            </div>
          </div>
        </div>
      </div>
      <br />
    </>
  );
}

export default StaffShips;
